var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('keep-alive',[(_vm.konectVan.state == 'home')?_c('HomeKonectVan'):_vm._e(),(_vm.konectVan.state == 'detail')?_c('DetailKonectVan'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }